define('shared/initializer/form/newHouseAdapters/mixins/upsell/Payment',[
    'shared/lib/RSVP',
    'shared/util/state',
    'shared/util/state/adapters/persistent',
    'shared/util/state/adapters/order',
    'shared/util/checkout/checkout',
    'shared/initializer/form/constants'
], 
function (
    RSVP,
    state,
    persistentAdapter,
    orderAdapter,
    checkoutUtil,
    constants
) {
    'use strict';

    function retrievingOffer() {
        var upsellInfo;

        return state.adapters.add(persistentAdapter)
            .then(function(){
                return state.get('persistent.upsell');
            })
            .then(function(values){
                upsellInfo = values && values[0] && values[0].value;

                if (!upsellInfo) {
                    return [];
                }
                    
                return RSVP.resolve(upsellInfo.selectedOffers);
            });
    }

    function doActualPageLoad() {
        var offers;
        return retrievingOffer()
            .then(function(value){
                offers = value;
                return state.adapters.add(orderAdapter);
            })
            .then(function() {
                if (offers.length <= 0) {
                    return;
                }

                return state.push(constants.State.OrderOfferId, offers);
            });
    }

    function Ctor() { }

    Ctor.prototype.doPageLoad = function() {
        var me = this;
        var flowType;
        
        return checkoutUtil.getCurrentFlowType()
            .then(function(ft){
                flowType = ft;
                if (flowType !== constants.CheckoutFlowType.Upsell) {
                    return RSVP.resolve();
                }
                else {
                    doActualPageLoad.call(me);
                }
            });
    };

    return Ctor;
});
